const normalizeId = (value) => (
  value === null || value === undefined
    ? ''
    : String(value).trim().toLowerCase()
);

export const getCompanyRecordId = (company) => (
  company?.id ||
  company?.company_id ||
  company?.companyId ||
  ''
);

export const getCompanyOwnerUserId = (company) => (
  company?.user_id ||
  company?.userId ||
  company?.owner_user_id ||
  company?.ownerUserId ||
  company?.representative_user_id ||
  ''
);

export const getUserCompanyId = (user) => (
  user?.company_id ||
  user?.companyId ||
  user?.company?.id ||
  user?.company?.company_id ||
  user?.company?.companyId ||
  ''
);

export const isOwnCompany = (company, user) => {
  if (!company || !user) return false;

  const currentUserId = normalizeId(user.id || user.user_id || user.userId);
  const companyOwnerUserId = normalizeId(getCompanyOwnerUserId(company));
  if (currentUserId && companyOwnerUserId && currentUserId === companyOwnerUserId) {
    return true;
  }

  const currentUserCompanyId = normalizeId(getUserCompanyId(user));
  const companyRecordId = normalizeId(getCompanyRecordId(company));
  return Boolean(currentUserCompanyId && companyRecordId && currentUserCompanyId === companyRecordId);
};

